const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-del",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.7 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M94,32.9c0,18.2-14.7,32.9-32.9,32.9s-32.9-14.7-32.9-32.9S42.8,0,61,0s32.9,14.7,32.9,32.9ZM87,32.9c0-7.2-2.5-13.3-7.6-18.4s-11.2-7.6-18.4-7.6-13.3,2.5-18.4,7.6c-5.1,5.1-7.6,11.2-7.6,18.4s2.5,13.3,7.6,18.4c5.1,5.1,11.2,7.6,18.4,7.6s13.3-2.5,18.4-7.6c5.1-5.1,7.6-11.2,7.6-18.4h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,107.9c-8.6-25.4-28.1-38.1-58.2-38.1s-6.7.2-9.9.6c-.1.1-1.5,1.6-1.1,3.6.3,1.5,1.4,2.7,2.9,3.2,2.6-.3,5.3-.4,8.2-.4,26.9,0,44.1,11.1,51.7,33.4.9,2.7.5,5.2-1.4,7.4-1.9,2.3-4.5,3.5-7.7,3.5h-50.2c-1.9.1-3.5,1.3-4,3-.7,2,.5,3.8.7,3.9h53.6c5.4,0,9.7-2,13.1-6,3.5-4.2,4.4-8.9,2.6-14.1Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3,77c11.9,0,21.5,9.7,21.5,21.6,0,11.9-9.7,21.5-21.6,21.5-11.9,0-21.5-9.7-21.5-21.6,0-8.6,5.2-16.4,13.1-19.8,2.7-1.1,5.5-1.7,8.4-1.7M29.3,69.3c-16.2,0-29.3,13.1-29.3,29.3s13.1,29.3,29.3,29.3,29.3-13.1,29.3-29.3-13.1-29.3-29.3-29.3h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4,94.1h-20.1c-1.9,0-3.3,2.1-3.3,4.7s1.5,4.7,3.3,4.7h20.1c1.9,0,3.3-2.1,3.3-4.7s-1.5-4.7-3.3-4.7Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDel);
export default __webpack_public_path__ + "static/media/user-del.cf5391fd1a38bb1a2bf70513882154bc.svg";
export { ForwardRef as ReactComponent };